import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95fd8640"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "detail-item" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { class: "table-thead" }
const _hoisted_11 = { class: "table-body" }
const _hoisted_12 = ["src"]

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice, platformOrderItemSettleTypeDict } from '../data_old'
import { isMultiStore } from '@/store'
import { showCurrentUnit } from '@/util/useYan'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: Number,
    default: 1
  }
},
  setup(__props) {



const productColumns = [
  { prop: 'productImg', label: t('商品图片') },
  { prop: 'productSku', label: t('平台商品SKU') },
  { prop: 'productPropertiesName', label: t('规格') },
  // { prop: 'productTitle', label: t('商品信息') },
  { prop: 'settlePrice', label: t('单价') },
  { prop: 'num', label: t('数量') },
  { prop: 'settleMoney', label: t('总价') }
]

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "500px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowName) + "(" + _toDisplayString(__props.rowItemDetail?.bizContentCustomer) + ")", 1)
        ]),
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.orderNo), 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail?.createTime)), 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总数量')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.customerWalletFundFlowOrderDTO?.num ?? 0), 1)
      ]),
      _createElementVNode("p", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总价')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail?.customerWalletFundFlowOrderDTO?.money ?? 0)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')), 1)
      ]),
      _createElementVNode("table", _hoisted_9, [
        _createElementVNode("thead", _hoisted_10, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productColumns, (item) => {
              return _createElementVNode("th", {
                key: item.prop,
                width: "157"
              }, _toDisplayString(item.label), 1)
            }), 64))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.rowItemDetail.customerWalletFundFlowOrderDTO?.customerWalletFundFlowGoodsDTOList || []), (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.productSku
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productColumns, (v) => {
                return _createElementVNode("td", {
                  key: v.prop
                }, [
                  (v.prop === 'productPropertiesName')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((row[v.prop] || '').split(';'), (prop) => {
                        return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                      }), 128))
                    : (v.prop === 'productImg')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          referrerPolicy: "no-referrer",
                          src: row[v.prop],
                          alt: "",
                          style: {"width":"60px"}
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(row[v.prop]), 1)
                        ], 64))
                ])
              }), 64))
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})